let slotTypes =
    [
        { id: 1, name: "横幅" },
        { id: 2, name: "插屏" },
        { id: 3, name: "开屏" },
        { id: 4, name: "信息流" },
        { id: 5, name: "视频" },
    ];
let publisherSlotTypes =
    [
        { id: 1, name: "横幅广告", disable: true },
        { id: 2, name: "插屏广告", disable: true },
        { id: 3, name: "开屏广告", des: "用户启动或切换回App时展示的广告", img: "~@/assets/images/splash.svg" },
        { id: 4, name: "信息流广告", des: "App推荐列表（信息流）里展示的广告", img: "feed" },
        { id: 5, name: "激励广告", des: "用户选择观看视频广告来换取应用或游戏内的奖励", img: "rewarded" },
    ];


let slotStatus =
    [
        { id: 0, name: "禁用", type: "danger" },
        // { id: 1, name: "测试", type: "warning" },
        { id: 2, name: "正常", type: "default" },
    ];
let slotState =
    [
        { id: 1, name: "测试", type: "warning" },
        { id: 2, name: "正式", type: "default" },
    ];
let appTypes =
    [
        { id: 0, name: "Android" },
        { id: 1, name: "iOS" },
        { id: 3, name: "快应用" },
    ];

let auditStatus =
    [
        { id: 0, name: "待审核" },
        { id: 1, name: "审核通过" },
        { id: 2, name: "审核拒绝" },
    ];

let slotSettingStatus =
    [
        { id: 0, name: "关闭", type: "info" },
        { id: 1, name: "开启", type: "success" },
    ];

let priceType =
    [
        { id: 1, name: "目标价" },
        { id: 2, name: "实时竞价" },
    ];


let renderingType =
    [
        { id: 1, name: "SDK渲染" },
        { id: 2, name: "开发者自渲染" },
    ];
let appCategory = [
    {
        value: 'zhinan', label: '指南', children: [
            { value: 'zhinan', label: '指南', }
        ]
    }
];
let apiTypes =
    [
        { id: 1, name: "标准API" },
        { id: 2, name: "自定义API" },
        { id: 3, name: "SDK" },
    ];

let controlPriceStatus =
    [
        { id: 0, name: "关闭", type: "info" },
        { id: 1, name: "开启", type: "success" },
    ];
let pushState =
    [
        { id: 0, name: "未发布", type: "info" },
        { id: 1, name: "已发布", type: "success" },
    ];
let budgetClassTypes1 =
    [
        { id: 1, name: "联盟预算" },
        { id: 2, name: "电商预算" },
    ];

let budgetClassTypes2 = [
    { id: 10, name: "百度", parentId: 1 },
    { id: 11, name: "汇川", parentId: 1 },
    { id: 12, name: "快手", parentId: 1 },
    { id: 13, name: "聚合电商", parentId: 1 },
    { id: 14, name: "uc", parentId: 1 },
    { id: 15, name: "爱奇艺", parentId: 1 },
    { id: 16, name: "ov", parentId: 1 },
    { id: 19, name: "其它", parentId: 1 },

    { id: 20, name: "京东", parentId: 2 },
    { id: 21, name: "阿里", parentId: 2 },
    { id: 22, name: "美团", parentId: 2 },
    { id: 23, name: "拼多多", parentId: 2 },
    { id: 24, name: "K2", parentId: 2 },
    { id: 25, name: "启航", parentId: 2 },
    { id: 29, name: "其它", parentId: 2 },
]

let getEmunName = function (emun, value) {
    let name = "-";
    if (value === null || value === "") return name;
    emun.forEach(element => {
        if (element.id === value) name = element.name;
    });
    if (name == "-")
        name = value;
    return name;
};
let roles = [
    { name: "管理员", id: "ADXADMIN" },
    { name: "商务", id: "ADXDB" },
    { name: "商务1", id: "ADXDB1" },
    { name: "媒界", id: "ADXMD" },
    { name: "运营", id: "ADXOP" },
    { name: "媒体平台用户", id: "SSPADMIN" },
    { name: "应用开发者", id: "PUBLISHER" }
]
let adTypeForView = [
  { id: 1, name: "下载" },
  { id: 2, name: "跳转页面" },
  { id: 3, name: "调起应用" },
  { id: 4, name: "未知" },
]
export default {
    slotTypes,
    publisherSlotTypes,
    slotStatus,
    appTypes,
    auditStatus,
    slotSettingStatus,
    priceType,
    slotState,
    renderingType,
    appCategory,
    roles,
    getEmunName,
    apiTypes,
    controlPriceStatus,
    pushState,
    adTypeForView,
    budgetClassTypes1,
    budgetClassTypes2
}